import searchReducer from './search.slice';

export * from './search.slice';
export * from './search.thunk';

export default searchReducer;
